<nz-divider></nz-divider>
<form nz-form *ngIf="load" [formGroup]="medicalDetailsGroup">
  <div nz-row>
    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="ml-lg">
        <nz-form-label nzRequired>
          Medical Ref No:
          <span nz-tooltip nzTitle="Medical Ref No">
            <i
              nz-icon
              class="icon-q"
              nzType="question-circle"
              nzTheme="outline"
            ></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'MedicalRefNo is Required'">
          <input
            required
            placeholder="Medical Ref No"
            id="medicalRefNo"
            formControlName="medicalRefNo"
            nz-input
          />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="ml-lg">
        <nz-form-label nzRequired>
          Medical Status
          <span nz-tooltip nzTitle="Medical Status">
            <i
              nz-icon
              class="icon-q"
              nzType="question-circle"
              nzTheme="outline"
            ></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Medical Status is Required'">
          <nz-select
            required
            [nzPlaceHolder]="'Medical Status'"
            id="medicalStatus"
            formControlName="medicalStatus"
          >
            <nz-option
              *ngFor="let fa of medicalStatusList"
              [nzLabel]="fa.label"
              [nzValue]="fa.label"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="ml-lg">
        <nz-form-label>
          Remarks
          <span nz-tooltip nzTitle="Remarks">
            <i
              nz-icon
              class="icon-q"
              nzType="question-circle"
              nzTheme="outline"
            ></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Remarks is Required'">
          <textarea
            required
            rows="2"
            id="remarks"
            formControlName="remarks"
            nz-input
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div class="float-right">
        <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
      </div>
    </div>
  </div>
</form>
